import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import "./Forms.css";
// add .error to component for error state.

class Button extends PureComponent {
  static defaultProps = {
    classes: "",
    linkTo: "",
    Type: "filled", // filled or border
  };
  constructor(props) {
    super(props);
  }

  handleClick = () => {
    if (this.props.Disabled) {
      return;
    }
    this.props.onClick();
  };
  handleKeyDown = (event) => {
    if (this.props.Disabled) {
      return;
    }
    if (event.key === "Enter") {
      this.props.onClick();
    }
  };

  render() {
    const { Disabled, customButtonStyle } = this.props;
    const buttonType =
      this.props.Type == "filled" ? "button-filled" : "button-bordred--full";
    if (this.props.linkTo.length && !Disabled)
      return (
        <div className={`button-wrapper ${this.props.classes}`}>
          <Link
            to={this.props.linkTo}
            className="mark-buttons"
            onKeyDown={this.handleKeyDown}
          >
            <div
              className={`mark-buttons ${buttonType} ${
                Disabled ? " button-disabled" : ""
              }`}
              aria-disabled={Disabled}
              role="button"
              onClick={this.handleClick}
              style={customButtonStyle}
            >
              <span className="button-text">{this.props.children}</span>
            </div>
          </Link>
        </div>
      );
    else
      return (
        <div className={`button-wrapper ${this.props.classes}`}>
          <button
            aria-disabled={Disabled}
            className={`mark-buttons ${buttonType} ${
              Disabled ? " button-disabled" : ""
            }`}
            onClick={this.handleClick}
            onKeyDown={this.handleKeyDown}
            style={customButtonStyle}
          >
            <span className="button-text">{this.props.children}</span>
          </button>
        </div>
      );
  }
}
export default Button;
